"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
/** @ignore */
exports.messages = {
    callbackIsNotFunction: 'The provided callback is not a function',
    dragDropInitFailed: 'Unable to initialize drag-drop',
    dragDropInitFailedInit: 'Unable to initialize drag-drop as part of init flow',
    failedToGenerateIframe: 'Unable to generate IFRAME for download. Using new window',
    getInstallerError: 'Unable to get latest installers',
    getAllTransfersFailed: 'Unable to get all transfers',
    getTransferFailed: 'Unable to get transfer',
    invalidEndpoint: 'The specified endpoint is not a valid URL',
    loadingProtocol: 'Launching IBM Aspera for Desktop',
    modifyTransferFailed: 'Unable to modify transfer',
    notValidTransferSpec: 'The supplied transferSpec is not valid',
    removeTransferFailed: 'Unable to remove transfer',
    resumeTransferFailed: 'Unable to resume transfer',
    serverError: 'Unable to connect to IBM Aspera for Desktop server',
    serverNotVerified: 'IBM Aspera SDK has not been verified. Run test or init first',
    setBrandingFailed: 'Unable to set custom branding',
    showDirectoryFailed: 'Unable to show transfer directory',
    showSelectFileDialogFailed: 'Unable to show select file dialog',
    showSelectFolderDialogFailed: 'Unable to show select folder dialog',
    showPreferencesFailed: 'Unable to show preferences',
    stopTransferFailed: 'Unable to stop transfer',
    transferFailed: 'The transfer failed to initiate',
    unableToFindElementOnPage: 'Unable to find the element on the current page',
    unableToReadDropped: 'The dropped item could not be parsed. Please try selecting via the select file/folder option',
    websocketClosedError: 'The websocket was closed due to an error',
    websocketClosedUnexpect: 'The websocket was closed unexpectedly',
    websocketNotReady: 'The websocket is not ready. Run init first',
    httpNotAvailable: 'IBM Aspera HTTP Gateway is not available',
    httpInitFail: 'IBM Aspera HTTP Gateway could not be started',
    filePickerCancel: 'User canceled the select file or folder dialog.',
    fileNotAllowed: 'TransferSpec contained file not selected by user.',
    httpNetworkFail: 'HTTP network encountered unknown error.',
};
